<div class="hasTabs">
    <!--nav end-->
    <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg cat__core__top-sidebar--tabs">

        <span class="cat__core__title d-block mt-2 mb-0 mb-lg-2">
            <strong>Edit Profile</strong>
        </span>

    </nav>

    <div class="nav-tabs-horizontal tab-body" id="profile-page-tabs">
        <ul ngbNav #tabset="ngbNav"
            (navChange)="onTabChange($event)"
            class="nav-tabs">
            <li ngbNavItem id="profile-tab">
                <a ngbNavLink>
                    <span class="d-inline-block d-lg-none">Profile</span>
                    <span class="d-none d-lg-inline-block">My Profile</span>
                </a>
                <ng-template ngbNavContent>
                    <main-tab (onFormAdd)="addForm($event)"></main-tab>
                </ng-template>
            </li>
            <li ngbNavItem *ngIf="eventService?.selectedEvent?.cssClass === 'program-tnt'" id="emergency-tab">
                <a ngbNavLink>
                    <span class="d-inline-block d-lg-none">Contacts</span>
                    <span class="d-none d-lg-inline-block">Emergency Contacts</span>
                </a>
                <ng-template ngbNavContent>
                    <emergency-tab (onFormAdd)="addForm($event)"></emergency-tab>
                </ng-template>
            </li>
            <li ngbNavItem *ngIf="eventService?.selectedEvent?.cssClass === 'program-tnt'" id="insurance-health-tab">
                <a ngbNavLink>
                    <span class="d-inline-block d-lg-none">Insurance</span>
                    <span class="d-none d-lg-inline-block">Insurance &amp; Health</span>
                </a>
                <ng-template ngbNavContent>
                    <insurance-tab (onInit)="addForm($event)"></insurance-tab>
                </ng-template>
            </li>
            <li ngbNavItem id="settings-tab">
                <a ngbNavLink>
                    <span class="d-inline-block d-lg-none">Password</span>
                    <span class="d-none d-lg-inline-block">Manage Password</span>
                </a>
                <ng-template ngbNavContent>
                    <settings-tab (onFormAdd)="addForm($event)"></settings-tab>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="tabset" class="mt-2"></div>

    </div>
</div>
